export function camelCase(val: string | null | undefined): string {
  // hello world > Hello world
  return val ? val.charAt(0).toUpperCase() + val.slice(1).toLowerCase() : ''
}
